import { ChartsContainer } from '@mui/x-charts/ChartsContainer';
import { LinePlot, MarkPlot, lineClasses } from '@mui/x-charts/LineChart';

const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
const xLabels = [
  'Page A',
  'Page B',
  'Page C',
  'Page D',
  'Page E',
  'Page F',
  'Page G',
];

export default function TinyLineChart() {
  return (
    <ChartsContainer
      width={500}
      height={300}
      series={[{ type: 'line', data: pData, showMark: true }]}
      xAxis={[{ scaleType: 'point', data: xLabels, position: 'none' }]}
      yAxis={[{ position: 'none' }]}
      sx={{
        [`& .${lineClasses.line}`]: {
          stroke: '#8884d8',
          strokeWidth: 2,
        },
        [`& .${lineClasses.mark}`]: {
          stroke: '#8884d8',
          r: 4, // Modify the circle radius
          fill: '#fff',
          strokeWidth: 2,
        },
      }}
      disableAxisListener
    >
      <LinePlot />
      <MarkPlot />
    </ChartsContainer>
  );
}
